import { Friendship } from '../models';
import { FriendshipRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class SendFriendRequestUseCase {
  constructor(private friendshipRepository: FriendshipRepository) {}

  async execute(requesterId: string, addresseeId: string): Promise<Friendship> {
    logger.debug('SendFriendRequest', 'Sending friend request', { requesterId, addresseeId });

    // Check if already friends
    const areFriends = await this.friendshipRepository.areFriends(requesterId, addresseeId);
    if (areFriends) {
      throw new Error('Already friends with this user');
    }

    // Check if there's a pending request in either direction
    const existingRequest = await this.friendshipRepository.getPendingRequestBetween(
      requesterId,
      addresseeId
    );

    if (existingRequest) {
      // If the other user already sent a request, auto-accept it
      if (existingRequest.requesterId === addresseeId) {
        logger.debug('SendFriendRequest', 'Auto-accepting reverse request');
        return await this.friendshipRepository.acceptRequest(existingRequest.id);
      }
      throw new Error('Friend request already sent');
    }

    const friendship = await this.friendshipRepository.sendRequest(requesterId, addresseeId);

    logger.debug('SendFriendRequest', 'Friend request sent successfully');

    return friendship;
  }
}
